export enum StatusSolicitacaoEnum {
    'Em_analise' = 'Em Análise',
    'Aprovado' = 'Aprovado',
    'Reprovado'= 'Reprovado',
    'Cancelado' = 'Cancelado'
}